import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ImagilityBaseResponse } from '../data/models/response.model';


@Injectable({
    providedIn: 'root'
})
export class EmailNotifyService {

    constructor(private httpClient: HttpClient) { }


    postNotifySettings(payload) {
        return this.httpClient.post(`/policies/notificationSettings`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    getNotifySettings() {
        return this.httpClient.get(`/policies/notificationSettings`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }


    postPrivacySettings(payload) {
        return this.httpClient.post(`/settings/privacySettings`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    getPrivacySettings() {
        return this.httpClient.get(`/settings/privacySettings`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    listUserNotifyPetitioner(companyType, payload) {
        return this.httpClient.post(`/policies/companyType/${companyType}/companyPrivacySettings/list`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    postUserNotifyPetitioner(companyType, payload){
        return this.httpClient.post(`/policies/companyType/${companyType}/companyPrivacySettings`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    listUserNotifyAssCompany(payload) {
        return this.httpClient.post(`/policies/companyPrivacySettings/list`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    postUserNotifyAssCompany(payload){
        return this.httpClient.post(`/policies/companyPrivacySettings`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    listUserNotifyBeneficiary(payload) {
        return this.httpClient.post(`/policies/beneficiaryCatPrivacySettings/list`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    postUserNotifyBeneficiary(payload){
        return this.httpClient.post(`/policies/beneficiaryCatPrivacySettings`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    getAttorneyAdminDetails(){
        return this.httpClient.get(`/policies/companyType/attorneyAdmin/companyPrivacySettings`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    postAttorneyAdminDetails(payload){ 
        return this.httpClient.post(`/policies/companyType/attorneyAdmin/companyPrivacySettings`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    getListOfNotifications(payload){
        return this.httpClient.post(`/policies/notificationPrivacySettings/list`, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }

    postListOfNotifications(payload){ 
        return this.httpClient.post(`/policies/notificationPrivacySettings `, payload).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && response.status === 200) {
                    return response;
                }
            })
        );
    }




}